// External Imports
import { MdPerson } from "react-icons/md";

// Internal Imports

/** ========================================================================
 * * DomainSwitch Component
 * This component renders a switch to toggle scope domain.
 * ========================================================================== */

export default function Switch({ on, onSwitch, Icon = MdPerson, title }) {
  const bkgClasses = () => {
    let classes =
      "w-10 h-6 cursor-pointer rounded-full transition-all duration-300 flex items-center ";
    if (on) classes += "bg-green-600";
    else classes += "bg-stone-400";
    return classes;
  };

  const btnClasses = () => {
    let classes =
      "w-6 h-6 rounded-full transition-all duration-300 my-auto bg-white flex items-center justify-center ";
    if (on) classes += "translate-x-4";
    else classes += "translate-x-0";
    return classes;
  };

  const switchHandler = () => {
    onSwitch();
  };
  return (
    <div className={bkgClasses()} onClick={switchHandler} title={title}>
      <div className={btnClasses()}>
        {on ? (
          <Icon className="w-4 h-4 text-green-600" />
        ) : (
          <Icon className="w-4 h-4 text-stone-400" />
        )}
      </div>
    </div>
  );
}
